module.exports = __webpack_public_path__ + "img/no-sensor-ship.2d57c4a4.svg";